import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, shareReplay, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LastCallState {
  public lastBody: string | null = null;
  public lastUrl: string | null = null;
  public lastParams: string | null = null;
  // Store the observable so we can return the 'active' or 'completed' stream
  public lastObservable: Observable<HttpEvent<unknown>> | null = null;
  public callTime: Date = new Date();
}

export const callGuardInterceptor: HttpInterceptorFn = (req, next) => {
  const state = inject(LastCallState);

  const d = new Date();
  const currentParams = req.params.toString();

  // Check if it's a duplicate call within the time window and we have a stream to hook into
  if (state.lastUrl === req.url &&
      state.lastBody === JSON.stringify(req.body) &&
      state.lastParams === currentParams &&
      d.getTime() - state.callTime.getTime() < 1500 &&
      state.lastObservable) {
    state.callTime = new Date()
    console.warn('Warning', 'Call duplicate detected, returning active/cached observable.');
    return state.lastObservable;
  }


  // Store the content (body) and URL of the request
  state.lastBody = JSON.stringify(req.body);
  state.lastUrl = req.url;
  state.lastParams = currentParams;
  state.callTime = new Date();

  // This ensures late subscribers get the emission (response) even if it has already completed
  const request$ = next(req).pipe(
    shareReplay(1),
    catchError(err => {
      // If the request fails, clear the cache
      state.lastObservable = null;
      return throwError(() => err);
    })
  );

  state.lastObservable = request$;

  return request$;
};
